import { render, staticRenderFns } from "./InputsSection.vue?vue&type=template&id=74b3c1f1"
import script from "./InputsSection.vue?vue&type=script&lang=js"
export * from "./InputsSection.vue?vue&type=script&lang=js"
import style0 from "./InputsSection.vue?vue&type=style&index=0&id=74b3c1f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports